import { InsightsFiltersOptionsQuery } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import { makeEmployeeOptionsFromGraphQL } from 'modules/core/components/Filter/filters/premade/employeeOptions'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

export const useManagerOptions = (filtersOptionsData: InsightsFiltersOptionsQuery) => {
  const options = useUnsafeMemo(
    () =>
      orderBy(
        makeEmployeeOptionsFromGraphQL(filtersOptionsData.employees.employees),
        (option) => option.label,
        'asc'
      ),
    [filtersOptionsData]
  )

  return options
}
